/* eslint-disable @typescript-eslint/no-explicit-any */
import { ContactManagementConfigProviderPrivate } from '@/ui/providers/ContactManagementConfigProviderPrivate';
import { DialogHelper } from '@juvare/common-web-ui/DialogHelper';
import { SnackbarHelper } from '@juvare/common-web-ui/SnackbarHelper';
import { LoginCompletionWizard } from '@juvare/contact-management/ui/features/registration';
import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { FormConfigContextProvider } from '../features/forms/providers/FormConfigContextProvider';
import { baseName } from '../utils/utils';
import { ConfigLoader } from './ConfigLoader';

export const LoginCompletionApp: React.FC = () => {
    return <RouterProvider router={createBrowserRouter([{ path: '*', element: <LoginCompletionAppContent /> }], { basename: baseName })} />;
};

const LoginCompletionAppContent: React.FC = () => {
    return (
        <ContactManagementConfigProviderPrivate>
            <FormConfigContextProvider>
                <ConfigLoader>
                    <DialogHelper />
                    <SnackbarHelper />
                    <LoginCompletionWizard />
                </ConfigLoader>
            </FormConfigContextProvider>
        </ContactManagementConfigProviderPrivate>
    );
};
